module.exports = __webpack_public_path__ + "img/wechat.016ccaf9.svg";